var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formula"},[_c('prism',{attrs:{"language":"javascript"}},[_vm._v(_vm._s(_vm.code))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }